var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFirstIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.05743 12.8329C6.88243 12.8329 6.70743 12.8329 6.53243 12.8329C3.32409 12.5413 0.99076 9.68294 1.28243 6.47461C1.51576 3.67461 3.73243 1.45794 6.53243 1.22461C6.76576 1.22461 6.99909 1.34128 7.11576 1.51628C7.23243 1.69128 7.23243 1.98294 7.05743 2.15794C6.47409 2.91628 6.29909 3.84961 6.41576 4.78294C6.53243 5.71628 7.05743 6.53294 7.81576 7.05794C9.04076 7.99128 10.7324 7.99128 11.9574 7.05794C12.1324 6.94128 12.3658 6.88294 12.5991 6.99961C12.7741 7.11628 12.8908 7.34961 12.8908 7.58294C12.7741 9.15794 12.0158 10.5579 10.7908 11.5496C9.68243 12.3663 8.39909 12.8329 7.05743 12.8329ZM5.42409 2.56628C3.73243 3.14961 2.56576 4.66628 2.39076 6.53294C2.15743 9.09961 4.02409 11.3746 6.59076 11.6079C7.81576 11.7246 9.04076 11.3746 9.97409 10.5579C10.6158 10.0329 11.0824 9.33294 11.3741 8.57461C9.91576 9.09961 8.28243 8.86628 6.99909 7.93294C6.00743 7.17461 5.36576 6.12461 5.13243 4.89961C5.07409 4.08294 5.19076 3.32461 5.42409 2.56628Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstIcon);
export default __webpack_public_path__ + "static/media/first-icon.85a8b78800cd13ef059f6cfa0112c6fa.svg";
export { ForwardRef as ReactComponent };